// SearchBox.tsx

import React, { forwardRef } from 'react'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import { CSSProperties } from 'react'
import { Form, FormControlProps } from 'react-bootstrap'

export interface SearchBoxProps extends Omit<FormControlProps, 'onSubmit'> {
  placeholder?: string
  className?: string
  inputClassName?: string
  formClassName?: string
  size?: 'sm' | 'lg'
  style?: CSSProperties
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void // Add this line
}

const SearchBox = forwardRef<HTMLInputElement, SearchBoxProps>(
  (
    {
      placeholder,
      size,
      className,
      inputClassName,
      formClassName,
      style,
      onSubmit, // Destructure onSubmit
      ...rest
    }: SearchBoxProps,
    ref
  ) => {
    return (
      <div className={classNames('search-box', className)} style={style}>
        <form
          className={classNames('position-relative', formClassName)}
          onSubmit={onSubmit} // Attach onSubmit handler
        >
          <Form.Control
            type="search"
            placeholder={placeholder}
            className={classNames('search-input search', inputClassName)}
            size={size}
            ref={ref}
            {...rest}
          />
          <FontAwesomeIcon icon={faMagnifyingGlass} className="search-box-icon" />
        </form>
      </div>
    )
  }
)

export default SearchBox
